import PenIcon from '@tradera/blueprint/theme/icons2/pen.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { GtmService } from 'tradera/services/google-tagmanager/google-tagmanager-service';

type NewListingLinkProps = {
    isLoggedIn: boolean;
    isDesktop: boolean;
};

export const NewListingLink = ({
    isLoggedIn,
    isDesktop,
}: NewListingLinkProps) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const newListingLink = t('siteHeader_newListing');

    const trackClick = () => {
        GtmService.trackAction(
            'Top navigation',
            'New draft',
            'Link - New draft',
        );
    };

    return (
        <Button
            href={toLocalizedUrl('/selling/new')}
            aria-label={newListingLink}
            theme={isLoggedIn && isDesktop ? 'highlight' : 'text'}
            className={!(isLoggedIn && isDesktop) ? 'slim-header__button' : ''}
            title={newListingLink}
            data-ga-category="Top navigation"
            data-ga-action="New draft"
            data-ga-label="Link - New draft"
            data-nav-how-to-link
            onClick={trackClick}>
            <PenIcon className="icon icon-md d-block d-lg-none" />

            <span className="slim-header__link-text d-none d-lg-inline">
                {newListingLink}
            </span>
        </Button>
    );
};
